import { ISearchResults } from "@myinnsworth/models/ISearchResults";
import HttpServiceBase from "../httpServiceBase";
import { ISearchApplicantsRequestModel } from "./models/ISearchApplicantsRequestModel";
import { IApplicant } from "@myinnsworth/models/applicants/IApplicant";
import { ISearchInstitutionFundsRequestModel } from "./models/ISearchInstitutionFundsRequestModel";
import { IApplicantLosses } from "@myinnsworth/models/applicants/IApplicantLosses";

class ApplicantsHttpService extends HttpServiceBase {
    protected get serviceName(): string { return 'applicants' };

    public async searchInstitutions(model: ISearchApplicantsRequestModel): Promise<ISearchResults<IApplicant>> {
        return await this.typedGet<ISearchResults<IApplicant>>(this.buildSearchUrl(`${model.caseSlug}/search`, model));
    }

    public async SearchInstitutionFunds(model: ISearchInstitutionFundsRequestModel): Promise<ISearchResults<IApplicantLosses>> {
        return await this.typedGet<ISearchResults<IApplicantLosses>>(this.buildSearchUrl(`${model.caseSlug}/search/${model.institutionId}/funds`, model));
    }
}

const service = new ApplicantsHttpService();
export default service;